import type { HTMLAttributes, ReactNode } from 'react';
import { cx } from '@/shared/ui/cx';

export type PillTone = 'neutral' | 'green' | 'danger' | 'warn' | 'info' | 'inverse';

export type PillProps = HTMLAttributes<HTMLSpanElement> & {
  tone?: PillTone;
  /** Shows a leading status dot. */
  dot?: boolean;
  size?: 'sm' | 'md';
  children: ReactNode;
};

/** A status/label chip. Not interactive — use Button for anything clickable. */
export function Pill({
  tone = 'neutral',
  dot = false,
  size = 'md',
  className,
  children,
  ...rest
}: PillProps) {
  return (
    <span className={cx('pill', `pill--${tone}`, `pill--${size}`, className)} {...rest}>
      {dot ? <span className="pill__dot" aria-hidden /> : null}
      {children}
    </span>
  );
}

export type TagProps = HTMLAttributes<HTMLSpanElement> & {
  /** One of the six accent names, matching the shelf colour swatches. */
  color?: 'gray' | 'coral' | 'yellow' | 'green' | 'blue' | 'purple';
  children: ReactNode;
};

/** The soft `school-related` chip under a library card. */
export function Tag({ color = 'green', className, children, ...rest }: TagProps) {
  return (
    <span className={cx('tag', `tag--${color}`, className)} {...rest}>
      {children}
    </span>
  );
}
